import { useEffect, useMemo, useRef } from 'react';
import debounce from 'lodash.debounce';

const DEBOUNCE_WAIT = 1000;

const useDebounce = (callback: () => void) => {
  const ref = useRef<(() => void) | undefined>(undefined);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  return useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, DEBOUNCE_WAIT);
  }, []);
};

export default useDebounce;
